import { Guid } from 'guid-typescript';
import { CartService } from 'root/services/cart-service/cart.service';
import { Router } from '@angular/router';
import { LocalizationService, NoticebarService, FrontendContextService, MibpLogger, SimpleProductViewModelWithPrice, SignalR_CartAddProductErrorViewModel } from 'root/services';
import { DialogComponent } from 'root/shared/components/dialogs/dialog/dialog.component';
import { DialogButton } from 'root/shared/components/dialogs/dialog/dialog.types';
import { DialogButtonType } from 'root/shared/components/dialogs/dialog/dialog-button.enum';
import { LogService } from './../../services/logservice/log.service';
import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { NoticeType } from '../noticebar/noticebar.enum';
import { PriceAndAvailabilitySource, ProductPrice } from 'root/mibp-openapi-gen/models';
import { SimpleProductViewModel } from './../../mibp-openapi-gen/models/simple-product-view-model';
import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { ImageComponent } from 'root/components/image/image.component';
import { UpsellComponent } from 'root/components/upsell/upsell.component';
import { CrossSellComponent } from 'root/components/cross-sell/cross-sell.component';
import { TestIdDirective } from 'root/directives';
import { PriceStateComponent } from 'src/app/shared/components/status/price-state/price-state.component';
import { PriceStateContextDirective } from 'src/app/shared/directives/status/price-state-context/price-state-context.directive';

@Component({
  selector: 'mibp-addtocart-dialog',
  templateUrl: './addtocart-dialog.component.html',
  styleUrls: ['./addtocart-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DialogComponent,
    ResourceStringComponent,
    TestIdDirective,
    ImageComponent,
    UpsellComponent,
    CrossSellComponent,
    PriceStateComponent,
    PriceStateContextDirective
  ]
})
export class AddtocartDialogComponent implements OnInit {
  private cartService = inject(CartService);
  private frontendContext = inject(FrontendContextService);
  private router = inject(Router);
  private localizationService = inject(LocalizationService);
  private noticeBarService = inject(NoticebarService);
  private log: MibpLogger;
  protected upsellProductId?: number;
  protected crossSellProductIds?: number[];
  private cartId: Guid;
  private contactUsMessageRequestPrice: string;
  private dialogOptionShowPrices: boolean;

  protected priceAndAvailabilitySource = PriceAndAvailabilitySource.ProductSearch;
  protected hasDuplicates = false;
  protected hasUpsell = false;
  protected hasCrossSell = false;
  protected additionalProducts: number;
  protected dialogButtons: DialogButton[];
  protected firstTwoProducts: SimpleProductViewModelWithPrice[];
  protected isLoading: boolean;
  protected errorText: string;
  protected itemCodesText: string;
  @ViewChild(DialogComponent) private dialog: DialogComponent;

  constructor() {
    const logService = inject(LogService);

    this.log = logService.withPrefix(`addtocart-dialog`);
  }

  ngOnInit(): void {
    this.cartService.registerDialog(this);
    this.dialogButtons = [

      {
        id: 'close',
        resourceKey: 'Global_Dialog_Close',
        type: DialogButtonType.Secondary,
        minWidth: 150,
        automatedTestId: 'button-addtocart-dialog'
      },
      {
        id: 'gotocart',
        resourceKey: 'CartsDialog_Go_To_Cart',
        type: DialogButtonType.Primary,
        minWidth: 150,
        automatedTestId: 'button-addtocart-dialog-gotocart'
      },
    ];
    this.localizationService.getResourceString('Carts_PriceForProductMessage').then((resourceStringValue) => {
      this.contactUsMessageRequestPrice = resourceStringValue;
    });
  }

  closeDialog(): void {
    this.dialog.close();
  }

  showDialog(addedProducts: SimpleProductViewModel[], hasDuplicates: boolean, cartId: Guid, upsellProductId?: number, crossSellProductIds?: number[], productErrors?: SignalR_CartAddProductErrorViewModel[], upsellCrossellProductVm?: SimpleProductViewModel, showPrices = true): void {
    this.dialogOptionShowPrices = showPrices;
    this.cartId = cartId;
    addedProducts = addedProducts || [];
    if (productErrors && productErrors.length > 0) {
      //Filter out the invalid items because they were never added to cart
      productErrors.forEach(item => {
        addedProducts = addedProducts.filter(addedProduct => {return addedProduct.code != item.productCode;});
      });
    }

    this.additionalProducts = addedProducts.length > 2 ? addedProducts.length - 2 : 0;
    this.hasDuplicates = hasDuplicates;
    this.hasUpsell = upsellProductId ? true : false;
    this.upsellProductId = upsellProductId;
    this.hasCrossSell = crossSellProductIds && crossSellProductIds.length > 0;
    this.crossSellProductIds = crossSellProductIds;

    this.firstTwoProducts = addedProducts.slice(0, 2).map(c => c as SimpleProductViewModelWithPrice);

    if (productErrors && productErrors.length > 0) {
      const productNumberText = this.localizationService.get('Global_ProductNumber');
      this.errorText = this.localizationService.get("Cart_ProductsCouldNotBeAdded") + ':';
      productErrors.forEach(item => { this.errorText += ` ${productNumberText}: ${item.productCode}, `; });
    } else {
      this.errorText = '';
    }

    this.dialog.open();
  }



  dialogClick(e: DialogButton): void {
    if (e.id == "close") {
      this.dialog.close();

    } else {
      this.dialog.close();
      this.router.navigateByUrl(this.frontendContext.Navigation.ensureUrlLanguage('/home/shop/cart'));
    }
  }

  productHasBeenUpgradedByUpsell(): void {
    this.cartService.refreshCartItems();
    this.cartService.refreshCartWeightNPrice();
    this.closeDialog();
    this.noticeBarService.show('Upsell_SuccessUpgradeMessage', NoticeType.Success);
  }

  onCrossSellProductAddedToCart(): void {
    this.closeDialog();
  }
  onClickProductImage(productCode: string): void
  {
    this.closeDialog();
    this.frontendContext.Navigation.navigateToProductDetailsPage(productCode);
  }
  onCloseCrossSellUpsellDialog(close: boolean): void
  {
    if(close)
    {
      this.closeDialog();
    }
  }
}

export interface AddToCartProductWithPrice {
  code: string;
  productPrice?: ProductPrice;
}
